import { Box, Grid, GridItem } from "@chakra-ui/react";
import React, { useEffect } from "react";
import HeadingCompo from "../AboutMe/HeadingCompo";
import ProjectsCard from "./ProjectsCard";
import AOS from "aos";
import "aos/dist/aos.css";

const Projects = () => {
  // useEffect(() => {
  //   AOS.init();
  // }, []);

  return (
    <Box id="Projects">
      <HeadingCompo>Projects</HeadingCompo>
      <Box mt="30px">
        <Grid
          // gridAutoRows="1fr"
          templateColumns={{
            lg: "repeat(3, 1fr)",
            md: "repeat(2, 1fr)",
            sm: "repeat(1, 1fr)",
          }}
          gap="30px"
        >
          {PROJECTS.map((project) => (
            <GridItem key={project.id}>
              <ProjectsCard project={project} />
            </GridItem>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

const PROJECTS = [
  {
    id: 1,
    img: "./lynx-banner.png",
    title: "Lynx",
    description:
      "An ecommerce platform that provides Fashion and Beauty products. Created the whole ecommerce flow along with the User Authentication. Individual Project completed in 5 days.",
    techStack: ["React", "ChakraUI", "Axios", "React Router Dom"],
    github: "https://github.com/faizal-siddiqui/Lynx",
    website: "https://buyonlynx.netlify.app/",
  },
  {
    id: 4,
    img: "./upstyle.png",
    title: "Upstyle",
    description:
      "A Full Stack ecommerce platform that sells Mens and Women's Clothing. Contributed by creating backend as well as admin panel. Collaborative Project built by a team of 5 members.",
    techStack: [
      "React",
      "Css",
      "React Redux",
      "Redux thunk",
      "Axios",
      "React Router Dom",
      "Chakra-Ui",
    ],
    github: "https://github.com/kaushalragini/pushy-dime-8312",
    website: "https://upstylesss.netlify.app/",
  },
  {
    id: 6,
    img: "./buylance.png",
    title: "Buylance",
    description:
      "An ecommerce platform that provides Fashion Clothing and Accessories. Lead the team and Contributed by creating Products, Products Description page and admin panel. Collaborative Project built by a team of 5 members.",
    techStack: [
      "Typescript",
      "Chakra-Ui",
      "React-router-dom",
      "React-redux",
      "Redux-thunk",
    ],
    github: "https://github.com/faizal-siddiqui/Buylance",
    website: "https://buylance.netlify.app/",
  },
  {
    id: 2,
    img: "./royal-electronics-banner.png",
    title: "RoyalElectronics",
    description:
      "An ecommerce platform that provides Electronic gadgets. Lead the team and Contributed by designing the navigation bar, products page, and payment page. Collaborative Project built by a team of 4 members.",
    techStack: ["HTML", "CSS", "Javascript"],
    github: "https://github.com/faizal-siddiqui/Royal-Electronics",
    website: "https://animated-snickerdoodle-485283.netlify.app/index.html",
  },
  {
    id: 3,
    img: "./max-fashion-banner.png",
    title: "Max Fashion",
    description:
      "An ecommerce platform that sells all categories of fashion clothing. Contributed by designing the Landing Page, Products page, and Cart Page. Individual project completed in four days.",
    techStack: ["HTML", "CSS", "Javascript"],
    github: "https://github.com/faizal-siddiqui/Max-Fashion-Clone",
    website: "https://loquacious-pudding-f8bcce.netlify.app/",
  },
  {
    id: 5,
    img: "./denoapp.png",
    title: "Deno Merch",
    description:
      "A Clone of the Deno Merch app, where users can buy Deno merchandise. Contributed by creating redux state and products page and cart functionality. A small Individual Project completed in 3 days.",
    techStack: [
      "Next-Js",
      "Typescript",
      "Css",
      "React-Redux",
      "Redux thunk",
      "Chakra-Ui",
    ],
    github: "https://github.com/faizal-siddiqui/Deno-Merch",
    website: "https://deno-merch.netlify.app/",
  },
];

export default Projects;
